import { render } from "./NewApp.vue?vue&type=template&id=08e28438"
import script from "./NewApp.vue?vue&type=script&lang=js"
export * from "./NewApp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__